export const IneCompaniesView: React.FC = () => {
    return <div>IneCompaniesView</div>
}
